import "./IconArrowDropdown.scss";

type Props = {
  backgroundClass: "blue" | "white" | "black";
  thickness?: "thick" | "";
  size?: "lg" | "md" | "";
};

export const IconArrowDropdown = ({ backgroundClass = "black", thickness = "", size = "" }: Props) => {
  return (
    <span
      className={`icon-arrow-dropdown icon-arrow-dropdown--${backgroundClass} icon-arrow-dropdown--${thickness} icon-arrow-dropdown--${size}
      }`}
    ></span>
  );
};
